import { deleteShipment } from '../service/deleteShipment';
import showToast from '../components/ToastComponent';
import { AxiosError } from 'axios';

const useDeleteShipment = () => {
  const handleDeleteShipment = async (
    accessToken: string | undefined,
    orderId: number,
  ) => {
    if (!accessToken || !orderId) return;

    try {
      const status = await deleteShipment(accessToken, orderId);
      if (status === 204) {
        showToast({
          message: 'Shipment Deleted successfully',
          type: 'success',
        });
      } else {
        showToast({
          message: 'Failed to Delete Shipment',
          type: 'error',
        });
      }
    } catch (e) {
      const error = e as AxiosError;
      return (error as AxiosError).response?.status;
    }
  };

  return [handleDeleteShipment];
};

export default useDeleteShipment;
